import type { CostSlice } from './api';
import type { CostMetric } from './cost-metric';
import { Format } from './format';

/**
 * As quatro medidas que dizem POR QUE um recorte custou o que custou: quanto do
 * que entrou já estava em cache, quanto entrou, quanto saiu, e quanto da saída é
 * raciocínio interno — que o cliente não lê e a gente paga igual.
 */
export class SliceMetrics {
  constructor(private readonly slice: CostSlice) {}

  all(): CostMetric[] {
    const { tokens, split } = this.slice;
    return [
      {
        label: 'cache',
        value: Format.percent(tokens.cached, tokens.prompt),
        sub: `${Format.tokens(tokens.prompt - tokens.cached)} frios`,
      },
      {
        label: 'entrada',
        value: Format.tokens(tokens.prompt),
        sub: Format.band(split.inputCacheMiss + split.inputCacheHit),
      },
      {
        label: 'saída',
        value: Format.tokens(tokens.completion),
        sub: Format.band(split.output),
      },
      {
        label: 'raciocínio',
        value: Format.percent(tokens.reasoning, tokens.completion),
        sub: `${Format.tokens(tokens.reasoning)} tok`,
      },
    ];
  }
}
